import { render, staticRenderFns } from "./AgendaConfigForm.vue?vue&type=template&id=a7137c78&"
import script from "./AgendaConfigForm.vue?vue&type=script&lang=js&"
export * from "./AgendaConfigForm.vue?vue&type=script&lang=js&"
import style0 from "./AgendaConfigForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports